import axiosInstance from "../axiosInstance";

export const kamanService = {
  generateToken: async () => {
    try {
      let response = await axiosInstance.get(`/generate-kaman-token`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
